import { useQuery } from '@tanstack/react-query';
import {
  GetRoleUsersResponseSchema,
  type GetRoleUsersResponse,
  type UserSummary,
} from '@magimp/shared';
import { useApiClient } from '../api/context.js';

export function useRoleUsers(id: string) {
  const client = useApiClient();
  return useQuery<UserSummary[]>({
    queryKey: ['role', id, 'users'],
    queryFn: async ({ signal }) => {
      const res = await client.get<GetRoleUsersResponse>(
        `/roles/${id}/users`,
        { signal },
        GetRoleUsersResponseSchema,
      );
      return res.items;
    },
    enabled: !!id,
  });
}
